export const stringToColor = (str: string) => {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
        // tslint:disable-next-line:no-bitwise
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    let colour = '#';
    for (let i = 0; i < 3; i++) {
        // tslint:disable-next-line:no-bitwise
        const value = (hash >> (i * 8)) & 0xff;
        colour += ('00' + value.toString(16)).substr(-2);
    }
    return colour;
};

const monitoringColorMap: Record<string, string> = {
    total: '#3182bd',
    total_requests: '#3182bd',

    ok: '#07aa23',
    '200': '#07aa23',

    error_http_5xx: '#cb4102',
    '5xx': '#cb4102',

    error_http_4xx: '#cc7802',
    '4xx': '#cc7802',

    error_http_3xx: '#ccc702',
    '3xx': '#ccc702',

    error_http_timeout: '#aacc02',
    error_bad_response: '#02ccab',
    error_validation: '#5a06dc',
    error_other: '#cc028a',
    error_response_body_size: '#2006DC',
    discovery_error_validation: '#0e88d7',
    unknown_error: '#cc7802',
    error_parse: '#dc0677',

    '99%': '#df0707',
    '95%': '#e07907',
    '75%': '#e0d628',
};

export const getChartColor = (label: string) => {
    return monitoringColorMap[label] || stringToColor(label);
};
